import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default function Maison() {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    if (!ref.current) return

    const ctx = gsap.context(() => {
      const items = ref.current?.querySelectorAll('.maison__item')
      if (!items) return

      gsap.fromTo(
        items,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.2,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: ref.current,
            start: 'top 80%',
            once: true,
          },
        }
      )
    }, ref.current)

    return () => ctx.revert()
  }, [])

  const items = [
    {
      num: 'I',
      title: 'Considered',
      text: 'No queue, no rush. Each session begins with a consultation and ends only when the mirror agrees.',
    },
    {
      num: 'II',
      title: 'Crafted',
      text: 'Our artists train continuously in international technique — precision cutting, couture makeup, advanced skin science.',
    },
    {
      num: 'III',
      title: 'Personal',
      text: 'Your features, your story, your occasion. We design for the individual, never the trend alone.',
    },
  ]

  return (
    <section ref={ref} className="maison" id="maison">
      <div className="maison__inner">
        <div className="maison__header">
          <span className="maison__label">The Maison</span>
          <h2 className="maison__title">
            Where craftsmanship meets <em>quiet luxury</em>
          </h2>
          <p className="maison__subtitle">
            Every appointment is a private ritual, composed for you alone.
          </p>
        </div>

        <div className="maison__items">
          {items.map((item) => (
            <div key={item.num} className="maison__item">
              <span className="maison__num">{item.num}</span>
              <div className="maison__content">
                <h3 className="maison__item-title">{item.title}</h3>
                <p className="maison__item-text">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}